// Connect case mapping updates
export var ConnectCaseMappingStatus;
(function (ConnectCaseMappingStatus) {
    // Case has been sent to new collector
    ConnectCaseMappingStatus["Exported"] = "EXPORTED";
    // The original case collector has retracted the case
    ConnectCaseMappingStatus["Retracted"] = "RETRACTED";
    // The task the collector needed to perform was completed
    ConnectCaseMappingStatus["Completed"] = "COMPLETED";
    // There has been an update to the data that needs to be passed to the other party
    ConnectCaseMappingStatus["DataUpdated"] = "DATA_UPDATED";
})(ConnectCaseMappingStatus || (ConnectCaseMappingStatus = {}));
export var RetractionReason;
(function (RetractionReason) {
    RetractionReason["Collected"] = "COLLECTED";
    RetractionReason["ConnectionDisabled"] = "CONNECTION_DISABLED";
    RetractionReason["Rollback"] = "ROLLBACK";
    RetractionReason["Other"] = "OTHER";
})(RetractionReason || (RetractionReason = {}));
export var CompletionReason;
(function (CompletionReason) {
    CompletionReason["Collected"] = "COLLECTED";
    CompletionReason["TaskCompleted"] = "TASK_COMPLETED";
})(CompletionReason || (CompletionReason = {}));
// Entity mappings
export var EntityType;
(function (EntityType) {
    EntityType["Customer"] = "CUSTOMER";
    EntityType["Document"] = "DOCUMENT";
    EntityType["VoucherType"] = "VOUCHER_TYPE";
    EntityType["Interaction"] = "INTERACTION";
})(EntityType || (EntityType = {}));
//# sourceMappingURL=index.js.map